"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _uiUtil = require("@ctmobile/ui-util");

/**
 * 配置:
 el
 {
  position: [left | right | top | bottom] 默认是right
}

 布局:
 <div class="ct-surnames">

 <div class="ct-surnames-highlighted"></div>

 <div class="ct-surnames-content">

 <div class="ct-surnames-group">
 <a class="ct-surnames-group-title" data-name="A">A</a>
 <div class="ct-surnames-group-inner"></div>
 </div>

 </div>

 <div class="ct-surnames-index">
 <!-- <a class="ct-surnames-index-item" data-name="A">A</a> -->
 </div>

 </div>
 */
var selectorPrefix = 'ct-surnames-';
var duration = 100;
/**
 * initVar
 * @access private
 */

function initVar() {
  this.highlightedEl = this.el.querySelector(".".concat(selectorPrefix, "highlighted"));
  this.indexEl = this.el.querySelector(".".concat(selectorPrefix, "index"));
  this.contentEl = this.el.querySelector(".".concat(selectorPrefix, "content"));
}
/**
 * clickDetail
 * @param {Event} - e
 */


function clickDetail(e) {
  var target = e.target;
  e.preventDefault();

  if (this.key) {
    return false;
  }

  this.key = true;
  this.maskEl.style.display = 'block';

  _scrollToAnimation.call(this, target.dataset.name);
}
/**
 * moveDetail
 * @param {number} x
 * @param {number} y
 */


function moveDetail(x, y) {
  var index = findIndex.call(this, x, y);

  if (index) {
    console.log(index.name);
    this.highlightedEl.innerText = index.name;
    this.highlightedEl.style.display = 'block';
    var direction = getDirection.call(this);

    if (direction === 'vertical') {
      var translateY = index.offsetTop - Math.floor(index.height / 2);
      this.highlightedEl.style.transform = "translate3d(0,".concat(translateY, "px,0)");
    } else {
      var translateX = index.offsetLeft - index.width;
      this.highlightedEl.style.transform = "translate3d(".concat(translateX, "px,0,0)");
    }

    _scrollTo.call(this, index.name);
  }
}
/**
 * initEvent
 * @access private
 */


function initEvent() {
  var _this = this;

  if (_uiUtil.Dom6.isTouch()) {
    this.indexEl.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      clickDetail.call(_this, e);
    }); // 索引touchmove和mousemove

    this.indexEl.addEventListener('touchmove', function (e) {
      e.preventDefault();
      var y = e.changedTouches[0].clientY;
      var x = e.changedTouches[0].clientX;
      moveDetail.call(_this, x, y);
    });
    this.indexEl.addEventListener('touchend', function () {
      _this.highlightedEl.style.display = 'none';
      _this.highlightedEl.innerText = '';
      _this.highlightedEl.style.transform = 'translate3d(0,0,0)';
    });
  } else {
    this.indexEl.addEventListener('mousedown', function (e) {
      e.preventDefault();
      _this.startY = e.clientY;
      _this.startX = e.clientX;
      _this.mouseClickFlag = true;
    });
    this.indexEl.addEventListener('mousemove', function (e) {
      if (!_this.mouseClickFlag) return false;
      _this.mouseMoveFlag = true;
      e.preventDefault();
      var y = e.clientY;
      var x = e.clientX;
      moveDetail.call(_this, x, y);
    });
    this.indexEl.addEventListener('mouseleave', function () {
      _this.mouseClickFlag = false;
      _this.mouseMoveFlag = false;
      _this.highlightedEl.style.display = 'none';
      _this.highlightedEl.innerText = '';
      _this.highlightedEl.style.transform = 'translate3d(0,0,0)';
    });
    this.indexEl.addEventListener('mouseup', function (e) {
      if (_this.mouseMoveFlag) {
        _this.mouseClickFlag = false;
        _this.mouseMoveFlag = false;
        _this.highlightedEl.style.display = 'none';
        _this.highlightedEl.innerText = '';
        _this.highlightedEl.style.transform = 'translate3d(0,0,0)';
        return false;
      }

      e.preventDefault();
      clickDetail.call(_this, e);
    });
  }

  window.addEventListener('resize', function () {
    _this.update();
  });
}
/**
 * render
 * @access private
 */


function render() {
  var _this$config$position = this.config.position,
      position = _this$config$position === void 0 ? 'right' : _this$config$position;

  _uiUtil.Dom6.addClass(this.el, "".concat(selectorPrefix, "config-position-").concat(position));

  renderIndex.call(this);
  createIndexPosition.call(this);
}
/**
 * renderIndex
 * @access private
 */


function renderIndex() {
  var groupTitleEls = this.contentEl.querySelectorAll(".".concat(selectorPrefix, "group-title"));
  if (groupTitleEls.length === 0) return false;
  var indexNames = [];

  for (var i = 0; i < groupTitleEls.length; i++) {
    indexNames.push(groupTitleEls[i].dataset.name);
  }

  this.indexEl.innerHTML = '';
  var df = document.createDocumentFragment();

  for (var _i = 0; _i < indexNames.length; _i++) {
    df.appendChild(_uiUtil.Dom6.createElement("<a class=\"".concat(selectorPrefix, "index-item\" data-name=\"").concat(indexNames[_i], "\">").concat(indexNames[_i], "</a>")));
  }

  this.indexEl.appendChild(df);
}
/**
 * createIndexPosition
 * @access private
 */


function createIndexPosition() {
  var indexItemEls = this.indexEl.querySelectorAll(".".concat(selectorPrefix, "index-item"));
  this.indexPositionMap = []; // 计算每一项距离视口的top和bottom

  for (var i = 0; i < indexItemEls.length; i++) {
    var indexItemEl = indexItemEls[i];
    var indexName = indexItemEl.dataset.name;
    var rect = indexItemEl.getBoundingClientRect();
    this.indexPositionMap.push({
      name: indexName,
      top: rect.top,
      bottom: rect.bottom,
      left: rect.left,
      right: rect.right,
      offsetTop: indexItemEl.offsetTop,
      offsetLeft: indexItemEl.offsetLeft,
      width: indexItemEl.offsetWidth,
      height: indexItemEl.offsetHeight
    });
  }
}
/**
 * createMask
 * @access private
 */


function createMask() {
  this.maskEl = _uiUtil.Dom6.createElement("<div class='".concat(selectorPrefix, "mask'></div>"));
  document.body.appendChild(this.maskEl);
}
/**
 * scrollToAnimation
 * @param {String} - indexName
 * @access private
 */


function _scrollToAnimation(indexName) {
  var self = this;
  var targetEl = self.contentEl.querySelector(".".concat(selectorPrefix, "group-title[data-name='").concat(indexName, "']"));
  var srcTop = self.contentEl.scrollTop;
  var scrollVal = srcTop;
  var targetTop = targetEl.offsetTop;
  var setp = self.el.scrollHeight / (duration / (screen.updateInterval || 16.7) + (duration % (screen.updateInterval || 16.7) !== 0 ? 1 : 0));
  /**
   * scrollAnimation
   */

  function scrollAnimation() {
    if (srcTop < targetTop) {
      if (scrollVal + setp > targetTop) {
        scrollVal = targetTop;
      } else {
        scrollVal += setp;
      }
    } else if (scrollVal - setp < targetTop) {
      scrollVal = targetTop;
    } else {
      scrollVal -= setp;
    }

    self.contentEl.scrollTop = scrollVal;

    if (srcTop < targetTop) {
      if (scrollVal >= targetTop) {
        clear();
      } else {
        window.requestAnimationFrame(scrollAnimation);
      }
    } else if (scrollVal <= targetTop) {
      clear();
    } else {
      window.requestAnimationFrame(scrollAnimation);
    }

    function clear() {
      self.key = false;
      self.mouseClickFlag = false;
      self.maskEl.style.display = 'none';
      self.events.trigger('scroll', indexName);
    }
  }

  this.events.trigger('scrollBefore', indexName);
  window.requestAnimationFrame(scrollAnimation);
}
/**
 * scrollTo
 * @param {String} - indexName
 * @access private
 */


function _scrollTo(indexName) {
  var self = this;
  var targetTop = self.contentEl.querySelector(".".concat(selectorPrefix, "group-title[data-name='").concat(indexName, "']")).offsetTop;
  self.contentEl.scrollTop = targetTop;
  this.events.trigger('scroll', indexName);
}
/**
 * findIndex
 * @param {number} x
 * @param {number} y
 * @return {String} - indexName
 * @access private
 */


function findIndex(x, y) {
  var direction = getDirection.call(this);
  var val = direction === 'vertical' ? y : x;
  var low = 0;
  var high = this.indexPositionMap.length - 1;
  var middle;
  var target;

  while (low <= high && low <= this.indexPositionMap.length - 1 && high <= this.indexPositionMap.length - 1) {
    middle = high + low >> 1;
    var targetVal = this.indexPositionMap[middle];
    var t1 = void 0;
    var t2 = void 0;

    if (direction === 'vertical') {
      t1 = targetVal.top;
      t2 = targetVal.bottom;
    } else {
      t1 = targetVal.left;
      t2 = targetVal.right;
    }

    if (val >= t1 && val < t2) {
      target = targetVal;
      break;
    } else if (val < t1) {
      high = middle - 1;
    } else {
      low = middle + 1;
    }
  }

  if (target) {
    return target;
  } else {
    return null;
  }
}
/**
 * getDirection
 * @return {string}
 */


function getDirection() {
  var position = this.config.position;
  return position === 'left' || position === 'right' ? 'vertical' : 'horizontal';
}
/**
 * Surnames
 * @class Surnames
 * @classdesc Surnames
 */


var Surnames =
/*#__PURE__*/
function () {
  /**
   * constructor
   * @constructor
   * @param {HTMLElement} el
   */
  function Surnames(el, config) {
    (0, _classCallCheck2["default"])(this, Surnames);
    this.el = el;
    this.config = Object.assign({
      position: 'right'
    }, config);
    this.key = false;
    this.mouseClickFlag = false;
    this.mouseMoveFlag = false;
    this.events = new _uiUtil.Events();
    initVar.call(this);
    initEvent.call(this);
    createMask.call(this);
    render.call(this);
  }
  /**
   * scrollToAnimation
   * @param {String} - indexName
   */


  (0, _createClass2["default"])(Surnames, [{
    key: "scrollToAnimation",
    value: function scrollToAnimation(indexName) {
      _scrollToAnimation.call(this, indexName);
    }
    /**
     * scrollTo
     * @param {String} - ndexName
     */

  }, {
    key: "scrollTo",
    value: function scrollTo(indexName) {
      _scrollTo.call(this, indexName);
    }
    /**
     * update
     */

  }, {
    key: "update",
    value: function update() {
      renderIndex.call(this);
      createIndexPosition.call(this);
    }
    /**
     * on 注册事件
     * @param {string} type
     * @param {Function} handler
     */

  }, {
    key: "on",
    value: function on(type, handler) {
      this.events.on(type, handler);
    }
    /**
     * 删除指定type下的事件或清除所有
     * @param {string} type
     * @param {Function} handler
     */

  }, {
    key: "off",
    value: function off(type, handler) {
      if (type) {
        if (handler) {
          this.events.remove(type, handler);
        } else {
          this.events.clear(type);
        }
      } else {
        this.events.clearAll();
      }
    }
  }]);
  return Surnames;
}();
/**
 * SurnamesFactory
 */


var SurnamesFactory = {
  /**
   * 创建一个Surnames
   * @param {HtmlElement} - el
   * @param {Object} - config
   * @return {Surnames} - Surnames
   */
  create: function create(el, config) {
    return new Surnames(el, config);
  }
};
var _default = SurnamesFactory;
exports["default"] = _default;